(function(){
if(window.__gbLoaded){return}window.__gbLoaded=true;
var rm=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
var io=('IntersectionObserver' in window)?new IntersectionObserver(function(es){es.forEach(function(e){
  if(e.target.classList.contains('gb-reveal')&&e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target)}
  if(e.target.classList.contains('gb-count')&&e.isIntersecting){countUp(e.target);io.unobserve(e.target)}
  if(e.target.tagName==='VIDEO'){if(e.isIntersecting){var p=e.target.play();if(p&&p.catch)p.catch(function(){})}else e.target.pause()}
})},{threshold:.15}):null;

/* ===== moving rows: auto-run + swipe + mouse drag, infinite loop, speed/direction from data attributes ===== */
var MQ=[],mqIO=('IntersectionObserver' in window)?new IntersectionObserver(function(es){es.forEach(function(e){e.target._mqVis=e.isIntersecting})},{rootMargin:'120px'}):null;
function mqInit(t){
  if(t._mq||!t.children.length)return;t._mq=1;
  var orig=[].slice.call(t.children),clip=function(){orig.forEach(function(k){var c=k.cloneNode(true);c.setAttribute('aria-hidden','true');c.removeAttribute('id');[].forEach.call(c.querySelectorAll('a,button,input'),function(x){x.tabIndex=-1});t.appendChild(c)})};
  clip();t._mqOrig=orig.length;t._mqDir=t.getAttribute('data-dir')==='rev'?-1:1;t._mqSp=parseFloat(t.getAttribute('data-speed'))||0;t._mqPos=0;t._mqRel=0;
  t._mqVis=!mqIO;if(mqIO)mqIO.observe(t);
  function measure(){var a=t.children[0],b=t.children[t._mqOrig];if(!b)return;var h=b.offsetLeft-a.offsetLeft;if(h<=0)return;t._mqHalf=h;
    var sets=Math.round(t.children.length/t._mqOrig),need=Math.ceil(t.clientWidth/h)+1;while(sets<need&&sets<7){clip();sets++}
    if(!t._mqStarted){t._mqStarted=1;if(t._mqDir<0){t.scrollLeft=h-1;t._mqPos=h-1}}}
  t._mqMeasure=measure;
  (window.requestAnimationFrame||setTimeout)(measure);window.addEventListener('load',measure);window.addEventListener('resize',measure);setTimeout(measure,600);
  t.addEventListener('scroll',function(){var h=t._mqHalf;if(!h)return;var sl=t.scrollLeft;if(sl>=h)t.scrollLeft=sl-h;else if(sl<=0)t.scrollLeft=sl+h},{passive:true});
  t.addEventListener('pointerenter',function(e){if(e.pointerType==='mouse')t._mqHold=1});
  t.addEventListener('pointerleave',function(e){if(e.pointerType==='mouse')t._mqHold=0});
  t.addEventListener('focusin',function(){t._mqHold=1});t.addEventListener('focusout',function(){t._mqHold=0});
  t.addEventListener('touchstart',function(){t._mqHold=1},{passive:true});
  t.addEventListener('touchend',function(){t._mqRel=performance.now()+1400;t._mqHold=0},{passive:true});
  var dn=null;
  t.addEventListener('pointerdown',function(e){if(e.pointerType!=='mouse'||e.button)return;dn={x:e.clientX,sl:t.scrollLeft,m:0}});
  t.addEventListener('pointermove',function(e){if(!dn)return;var dx=e.clientX-dn.x;if(!dn.m&&Math.abs(dx)>5){dn.m=1;t.classList.add('is-drag');try{t.setPointerCapture(e.pointerId)}catch(x){}}if(dn.m)t.scrollLeft=dn.sl-dx});
  function up(){if(dn&&dn.m){t._mqNoClick=1;setTimeout(function(){t._mqNoClick=0},50)}dn=null;t.classList.remove('is-drag')}
  t.addEventListener('pointerup',up);t.addEventListener('pointercancel',up);
  t.addEventListener('click',function(e){if(t._mqNoClick){e.preventDefault();e.stopPropagation()}},true);
  MQ.push(t);
}
var mqLast=0;
function mqTick(ts){window.__gbVel=(window.__gbVel||0)*.94;
  var dt=Math.min((ts-(mqLast||ts))/1000,.1);mqLast=ts;var now=performance.now();
  for(var i=0;i<MQ.length;i++){var t=MQ[i],h=t._mqHalf;if(!h)continue;
    if(!t._mqVis||t._mqHold||!t._mqSp||rm||t.classList.contains('is-drag')||now<t._mqRel||now<(t._mqBtn||0)){t._mqPos=t.scrollLeft;continue}
    if(Math.abs(t.scrollLeft-t._mqPos)>2)t._mqPos=t.scrollLeft;
    var p=t._mqPos+t._mqDir*t._mqSp*dt*(1+(window.__gbVel||0));if(p>=h)p-=h;if(p<=0)p+=h;t._mqPos=p;t.scrollLeft=p}
  requestAnimationFrame(mqTick)}
requestAnimationFrame(mqTick);
function mqAll(){[].forEach.call(document.querySelectorAll('[data-gb-mq]'),mqInit)}
document.addEventListener('shopify:section:load',function(){mqAll();document.querySelectorAll('.gb-vid video').forEach(function(v){v.muted=true;io&&io.observe(v)})});
function init(){
  mqAll();
  document.querySelectorAll('.gb-reveal:not(.is-in)').forEach(function(el){io&&!rm?io.observe(el):el.classList.add('is-in')});
  document.querySelectorAll('.gb-count:not([data-done])').forEach(function(el){if(io&&!rm){el.textContent=(el.dataset.prefix||'')+'0'+(el.dataset.suffix||'');io.observe(el)}else countUp(el)});
  document.querySelectorAll('[data-gb-header]').forEach(navInit);
  document.querySelectorAll('canvas[data-gb-mol]').forEach(molInit);
  document.querySelectorAll('.gb-vid video').forEach(function(v){v.muted=true;v.loop=true;v.setAttribute('playsinline','');io&&io.observe(v)});
}
document.addEventListener('pointermove',function(e){
  var g=e.target.closest&&e.target.closest('.gb-glass');if(!g)return;
  var r=g.getBoundingClientRect();g.style.setProperty('--mx',(e.clientX-r.left)+'px');g.style.setProperty('--my',(e.clientY-r.top)+'px')},{passive:true});
document.addEventListener('click',function(e){
  var n=e.target.closest('[data-gb-prev],[data-gb-next]');
  if(n){var car=n.closest('[data-gb-car]'),t=car.querySelector('.gb-track'),d=n.hasAttribute('data-gb-next')?1:-1;t._mqBtn=performance.now()+1600;t.scrollBy({left:d*(t.clientWidth*.7),behavior:'smooth'});return}
  var tb=e.target.closest('[data-gb-tab]');
  if(tb){var root=tb.closest('[data-gb-tabs]');root.querySelectorAll('[data-gb-tab]').forEach(function(b){b.setAttribute('aria-selected',b===tb?'true':'false')});root.querySelectorAll('[data-gb-pane]').forEach(function(p){p.hidden=p.dataset.gbPane!==tb.dataset.gbTab});return}
  var mu=e.target.closest('[data-gb-mute]');
  if(mu){var v=mu.closest('.gb-vid__media').querySelector('video');if(v){v.muted=!v.muted;mu.textContent=v.muted?'🔇':'🔊'}return}
  var a=e.target.closest('.gb-answer');
  if(a){var q=a.closest('[data-gb-quiz]');quizAnswer(q,+a.dataset.o);return}
  if(e.target.closest('[data-gb-retake]')){quizReset(e.target.closest('[data-gb-quiz]'))}
});
function steps(q){return q.querySelectorAll('.gb-qstep')}
function setProg(q,v){var b=q.querySelector('.gb-prog i');if(b)b.style.width=Math.round(v*100)+'%'}
function quizAnswer(q,o){
  q._a=q._a||[];q._a.push(o);var s=steps(q),i=q._a.length;
  if(i<s.length){s[i-1].hidden=true;s[i].hidden=false;setProg(q,i/s.length);return}
  s.forEach(function(x){x.hidden=true});setProg(q,1);
  var res=q.querySelectorAll('.gb-result'),c={},best=0,win=0;
  q._a.forEach(function(x){c[x]=(c[x]||0)+1});
  Object.keys(c).forEach(function(k){if(c[k]>best||(c[k]===best&&+k<win)){best=c[k];win=+k}});
  win=Math.min(win,res.length-1);
  res.forEach(function(r,k){r.hidden=k!==win});
  var h=q.querySelector('.gb-prog');if(h)h.hidden=true;
}
function quizReset(q){q._a=[];var s=steps(q);s.forEach(function(x,k){x.hidden=k!==0});q.querySelectorAll('.gb-result').forEach(function(r){r.hidden=true});
  var h=q.querySelector('.gb-prog');if(h)h.hidden=false;setProg(q,0)}

function hexPath(x,cx,cy,r){x.beginPath();for(var i=0;i<6;i++){var a=Math.PI/3*i+Math.PI/6;x.lineTo(cx+r*Math.cos(a),cy+r*Math.sin(a))}x.closePath();x.stroke()}
function sphereSprite(r,blur){
  var s=Math.ceil(r*2+blur*6+6),o=document.createElement('canvas');o.width=o.height=s;var x=o.getContext('2d'),c=s/2;
  if(blur&&('filter' in x))x.filter='blur('+blur+'px)';
  var g=x.createRadialGradient(c,c,r*.1,c,c,r);
  g.addColorStop(0,'rgba(255,255,255,.08)');g.addColorStop(.68,'rgba(246,110,190,.32)');g.addColorStop(.92,'rgba(255,255,255,.7)');g.addColorStop(1,'rgba(255,255,255,.9)');
  x.fillStyle=g;x.beginPath();x.arc(c,c,r,0,6.2832);x.fill();
  x.save();x.beginPath();x.arc(c,c,r*.93,0,6.2832);x.clip();x.strokeStyle='rgba(255,255,255,.4)';x.lineWidth=1;
  var h=Math.max(r/4,5),row=0;
  for(var yy=-r;yy<=r;yy+=h*1.5,row++){for(var xx=-r;xx<=r;xx+=h*1.732){hexPath(x,c+xx+(row%2?h*.866:0),c+yy,h*.98)}}
  x.restore();
  var hg=x.createRadialGradient(c-r*.36,c-r*.4,0,c-r*.36,c-r*.4,r*.55);hg.addColorStop(0,'rgba(255,255,255,.75)');hg.addColorStop(1,'rgba(255,255,255,0)');
  x.fillStyle=hg;x.beginPath();x.arc(c,c,r,0,6.2832);x.fill();
  return {c:o,s:s}}
function bokehSprite(r,col){
  var s=r*2+4,o=document.createElement('canvas');o.width=o.height=s;var x=o.getContext('2d'),c=s/2,g=x.createRadialGradient(c,c,0,c,c,r);
  g.addColorStop(0,'rgba('+col+',.95)');g.addColorStop(.7,'rgba('+col+',.55)');g.addColorStop(1,'rgba('+col+',0)');x.fillStyle=g;x.beginPath();x.arc(c,c,r,0,6.2832);x.fill();return o}
function molInit(cv){
  if(cv._m)return;cv._m=1;
  var ctx=cv.getContext('2d'),dpr=Math.min(window.devicePixelRatio||1,2),W=0,H=0,mols=[],dots=[],vis=true,raf=0,sc={},bk=[];
  var small=window.innerWidth<700,N=small?3:6,D=small?14:28,soft=cv.dataset.tone==='soft';
  function spr(r,b){var k=r+'_'+b;return sc[k]||(sc[k]=sphereSprite(r,b))}
  function build(){
    var p=cv.parentNode.getBoundingClientRect();W=p.width||800;H=p.height||600;cv.width=W*dpr;cv.height=H*dpr;ctx.setTransform(dpr,0,0,dpr,0,0);
    var u=Math.min(W,H*1.3);mols=[];dots=[];
    for(var i=0;i<N;i++){var z=Math.random(),R=Math.round((.05+.07*(1-z))*u+14);
      mols.push({x:Math.random()*W,y:Math.random()*H,vx:(Math.random()-.5)*.22,vy:(Math.random()-.5)*.16,R:R,rot:Math.random()*6.28,vr:(Math.random()-.5)*.0035,z:z,blur:z>.62?3:0,
        sats:[[0,2.15,.62],[2.1,2.0,.5],[4.0,2.2,.58]]})}
    mols.sort(function(a,b){return b.z-a.z});
    bk=[bokehSprite(18,'255,190,214'),bokehSprite(12,'250,160,195'),bokehSprite(8,'255,230,240')];
    for(var j=0;j<D;j++){dots.push({x:Math.random()*W,y:Math.random()*H,k:j%3,s:.6+Math.random()*1.1,vy:-.08-Math.random()*.25,ph:Math.random()*6.28,sp:.006+Math.random()*.012})}
  }
  function frame(t){
    ctx.clearRect(0,0,W,H);
    mols.forEach(function(m){
      var al=soft?.7:1;ctx.globalAlpha=al*(m.blur?.8:1);
      m.sats.forEach(function(s){var a=m.rot+s[0],d=m.R*s[1],sx=m.x+Math.cos(a)*d,sy=m.y+Math.sin(a)*d;
        ctx.lineCap='round';ctx.strokeStyle='rgba(255,255,255,.5)';ctx.lineWidth=m.R*.2;ctx.beginPath();ctx.moveTo(m.x,m.y);ctx.lineTo(sx,sy);ctx.stroke();
        ctx.strokeStyle='rgba(244,110,190,.55)';ctx.lineWidth=m.R*.08;ctx.stroke();
        var r=Math.round(m.R*s[2]),sp=spr(r,m.blur);ctx.drawImage(sp.c,sx-sp.s/2,sy-sp.s/2)});
      var sp0=spr(m.R,m.blur);ctx.drawImage(sp0.c,m.x-sp0.s/2,m.y-sp0.s/2);
      m.x+=m.vx;m.y+=m.vy;m.rot+=m.vr;var e=m.R*4;
      if(m.x<-e)m.x=W+e;if(m.x>W+e)m.x=-e;if(m.y<-e)m.y=H+e;if(m.y>H+e)m.y=-e;
    });
    dots.forEach(function(d){d.ph+=d.sp;d.y+=d.vy;if(d.y<-30){d.y=H+30;d.x=Math.random()*W}
      ctx.globalAlpha=.35+.5*Math.abs(Math.sin(d.ph));var b=bk[d.k];ctx.drawImage(b,d.x-b.width*d.s/2,d.y-b.height*d.s/2,b.width*d.s,b.height*d.s)});
    ctx.globalAlpha=1;
    if(vis&&!rm)raf=requestAnimationFrame(frame);
  }
  build();frame();
  if('IntersectionObserver' in window){new IntersectionObserver(function(es){vis=es[0].isIntersecting;if(vis&&!rm){cancelAnimationFrame(raf);raf=requestAnimationFrame(frame)}}).observe(cv)}
  var rt;window.addEventListener('resize',function(){clearTimeout(rt);rt=setTimeout(function(){build();if(rm)frame()},250)});
}
function countUp(el){
  if(el.dataset.done)return;el.dataset.done=1;
  var to=parseFloat(el.dataset.to)||0,suf=el.dataset.suffix||'',pre=el.dataset.prefix||'',t0=null,dur=1600;
  if(rm){el.textContent=pre+to+suf;return}
  function f(t){if(!t0)t0=t;var p=Math.min((t-t0)/dur,1),e=1-Math.pow(1-p,3);el.textContent=pre+Math.round(to*e)+suf;if(p<1)requestAnimationFrame(f)}
  requestAnimationFrame(f);
}
function navInit(h){
  if(h._gb)return;h._gb=1;
  var ul=h.querySelector('.gbh__nav ul'),pill=h.querySelector('.gbh__pill');
  function onScroll(){h.classList.toggle('is-scrolled',window.scrollY>24)}
  window.addEventListener('scroll',onScroll,{passive:true});onScroll();
  if(ul&&pill){
    var cur=ul.querySelector('[aria-current]');
    function to(li){var a=li.getBoundingClientRect(),b=ul.getBoundingClientRect();pill.style.width=a.width+'px';pill.style.transform='translateX('+(a.left-b.left)+'px)';pill.style.opacity=1}
    ul.querySelectorAll('.gbh__item').forEach(function(li){li.addEventListener('mouseenter',function(){to(li)});li.addEventListener('focusin',function(){to(li)})});
    ul.addEventListener('mouseleave',function(){if(cur)to(cur.closest('.gbh__item'));else pill.style.opacity=0});
    if(cur)to(cur.closest('.gbh__item'));
  }
}
document.addEventListener('click',function(e){
  var h=e.target.closest('[data-gb-header]');if(!h)return;
  if(e.target.closest('[data-gb-drawer]')){var o=h.classList.toggle('is-open');h.classList.remove('is-search');document.body.style.overflow=o?'hidden':'';return}
  if(e.target.closest('[data-gb-search]')){h.classList.add('is-search');h.classList.remove('is-open');document.body.style.overflow='hidden';var i=h.querySelector('.gbh__sform input');i&&setTimeout(function(){i.focus()},300);return}
  if(e.target.closest('[data-gb-close]')||e.target.closest('.gbh__over a')){h.classList.remove('is-open','is-search');document.body.style.overflow=''}
});
document.addEventListener('keydown',function(e){if(e.key==='Escape'){document.querySelectorAll('[data-gb-header]').forEach(function(h){h.classList.remove('is-open','is-search')});document.body.style.overflow=''}});
window.__gbInit=init;
if(document.readyState!=='loading')init();else document.addEventListener('DOMContentLoaded',init);
document.addEventListener('shopify:section:load',init);
})();

/* ===== FX: trending cursor + glass tilt/glare + scroll effects ===== */
(function(){
  if(window.__gbFx)return;window.__gbFx=1;
  var rm=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine=window.matchMedia&&matchMedia('(hover:hover) and (pointer:fine)').matches;
  var de=document.documentElement;

  /* 2. glass tilt + glare on cards */
  var SEL='.gb-prod,.gb-vid,.gb-why__c,.gb-rev,.gb-ingc,.gb-step,.gb-post,.gb-counter,.gb-cat';
  var NOTILT='.gb-cat';
  function bind(el){
    if(el.__gbfx)return;el.__gbfx=1;el.classList.add('gb-fx');
    var cs=getComputedStyle(el);if(cs.position==='static')el.style.position='relative';
    var g=document.createElement('i');g.className='gb-glare';el.appendChild(g);
    if(rm||!fine)return;
    var tilt=!el.matches(NOTILT);
    el.addEventListener('mousemove',function(e){
      var r=el.getBoundingClientRect(),x=(e.clientX-r.left)/r.width,y=(e.clientY-r.top)/r.height;
      el.style.setProperty('--mx',(x*100)+'%');el.style.setProperty('--my',(y*100)+'%');
      if(tilt){el.style.transform='perspective(900px) rotateX('+((.5-y)*9)+'deg) rotateY('+((x-.5)*11)+'deg) translateY(-6px)';el.classList.add('gb-tilting')}
    });
    el.addEventListener('mouseleave',function(){el.style.transform='';el.classList.remove('gb-tilting')});
  }
  function scan(){[].forEach.call(document.querySelectorAll(SEL),bind)}
  scan();document.addEventListener('shopify:section:load',scan);
  setTimeout(scan,800);

  /* 3. scroll effects: ticker speeds up + skews with scroll speed, carousel cards scale toward centre */
  if(!rm){
    var lastY=scrollY,vel=0,rows=[].slice.call(document.querySelectorAll('.gb-marq__row')),tracks=[].slice.call(document.querySelectorAll('.gb-track:not([data-gb-mq])'));
    function carousel(){
      tracks.forEach(function(t){
        var r=t.getBoundingClientRect();if(r.bottom<0||r.top>innerHeight)return;
        var c=r.left+r.width/2;
        [].forEach.call(t.children,function(k){var b=k.getBoundingClientRect(),d=Math.abs((b.left+b.width/2)-c)/(r.width*.6);d=Math.min(d,1);k.style.scale=(1-d*.07).toFixed(3);k.style.opacity=(1-d*.28).toFixed(3)});
      });
    }
    tracks.forEach(function(t){t.addEventListener('scroll',carousel,{passive:true})});
    var idleFx=false;
    (function tick(){
      if(document.hidden){requestAnimationFrame(tick);return}
      var y=scrollY;vel+=((y-lastY)-vel)*.14;lastY=y;
      var quiet=Math.abs(vel)<.03;
      if(!(quiet&&idleFx)){
        var s=Math.max(-10,Math.min(10,vel)),rate=1+Math.min(Math.abs(vel)*.35,5);
        rows.forEach(function(r){r.style.transform=quiet?'':'skewX('+(-s*.35)+'deg)';
          var an=r.querySelectorAll('.gb-marq__set');[].forEach.call(an,function(a){a.getAnimations&&a.getAnimations().forEach(function(x){x.playbackRate=quiet?1:rate})})});
        idleFx=quiet;
      }
      if(Math.abs(vel)>.05)carousel();
      requestAnimationFrame(tick);
    })();
    carousel();
  }
})();

/* ===== Smooth scroll (wheel inertia; touch stays native). Off via data-gb-smooth="0" on <html> ===== */
(function(){
  if(window.__gbSm)return;window.__gbSm=1;
  var de=document.documentElement;
  if(de.getAttribute('data-gb-smooth')==='0')return;
  if(window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  function start(){
    if(typeof Lenis==='undefined')return;
    if(window.matchMedia&&matchMedia('(pointer:coarse)').matches)return;
    var dur=parseFloat(de.getAttribute('data-gb-smooth-dur'))||1.15;
    var L=new Lenis({duration:dur,easing:function(t){return Math.min(1,1.001-Math.pow(2,-10*t))},smoothWheel:true,syncTouch:false,anchors:true});
    window.__gbLenis=L;
    L.on('scroll',function(){if(window.ScrollTrigger)ScrollTrigger.update()});
    (function raf(t){L.raf(t);requestAnimationFrame(raf)})(performance.now());
    document.addEventListener('shopify:section:load',function(){L.resize()});
  }
  if(document.readyState==='complete')start();else addEventListener('load',start);
})();

/* ===== Scroll animations: progress bar, word-reveal headings, hero/decor parallax, scroll-speed boost on moving rows ===== */
(function(){
  if(window.__gbAn)return;window.__gbAn=1;
  var rm=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
  function go(){
    var bar=document.createElement('div');bar.className='gb-progress';document.body.appendChild(bar);
    /* split headings into words */
    var io2=('IntersectionObserver' in window)&&new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io2.unobserve(e.target)}})},{threshold:.35});
    function split(){[].forEach.call(document.querySelectorAll('.gb-h2:not(.gb-split)'),function(h){
      if(h.children.length||!h.textContent.trim())return;
      var words=h.textContent.trim().split(/\s+/);h.textContent='';
      words.forEach(function(w,i){var s=document.createElement('span');s.className='gb-w';s.style.setProperty('--wi',i);var n=document.createElement('i');n.textContent=w;s.appendChild(n);h.appendChild(s);if(i<words.length-1)h.appendChild(document.createTextNode(' '))});
      h.classList.add('gb-split');io2&&!rm?io2.observe(h):h.classList.add('is-in')})}
    split();document.addEventListener('shopify:section:load',split);
    /* parallax targets */
    var hero=document.querySelector('.gb-hero__panel'),decos=[].slice.call(document.querySelectorAll('.gb-deco,.gb-fl,.gb-herobg img'));
    var last=scrollY,ticking=false,vh=innerHeight;
    function frame(){
      ticking=false;var y=scrollY,dy=y-last;last=y;
      window.__gbVel=Math.min(3,Math.max(window.__gbVel||0,Math.abs(dy)/28));
      var max=document.documentElement.scrollHeight-innerHeight;bar.style.transform='scaleX('+(max>0?Math.min(1,y/max):0)+')';
      if(rm)return;
      if(hero&&hero.classList.contains('is-in')&&!hero._rdy){hero._rdy=performance.now()}
      if(hero&&hero._rdy&&performance.now()-hero._rdy>1100&&y<vh*1.2){if(!hero._nt){hero._nt=1;hero.style.transition='none'}hero.style.transform='translate3d(0,'+(y*.16)+'px,0) scale('+(1-Math.min(y/vh,1)*.05)+')';hero.style.opacity=Math.max(0,1-y/(vh*.95))}
      decos.forEach(function(el,i){var r=el.getBoundingClientRect();if(r.bottom<-200||r.top>vh+200)return;el.style.translate='0 '+(((r.top+r.height/2)-vh/2)*(i%2?-.06:.09)).toFixed(1)+'px'})}
    function onS(){if(!ticking){ticking=true;requestAnimationFrame(frame)}}
    addEventListener('scroll',onS,{passive:true});addEventListener('resize',function(){vh=innerHeight;onS()});frame();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',go);else go();
})();
/* ===== v5.0 elegant motion: gentle magnetic buttons (desktop only) ===== */
(function(){
  if(matchMedia('(prefers-reduced-motion:reduce)').matches||!matchMedia('(hover:hover) and (pointer:fine)').matches)return;
  function go(){
    var els=document.querySelectorAll('.gb-hero .gb-btn,.gb-actions .gb-btn,.gbf .gb-btn');
    els.forEach(function(b){
      b.classList.add('gb-mag');
      b.addEventListener('pointermove',function(e){var r=b.getBoundingClientRect(),x=(e.clientX-r.left-r.width/2)/r.width,y=(e.clientY-r.top-r.height/2)/r.height;b.style.transform='translate('+(x*10).toFixed(1)+'px,'+(y*8-2).toFixed(1)+'px)'});
      b.addEventListener('pointerleave',function(){b.style.transform=''});
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',go);else go();
})();
/* ===== v6.0 mobile sticky shop button: shows after the hero, hides near the footer ===== */
(function(){
  function go(){
    var bar=document.querySelector('[data-gb-cta]');if(!bar)return;
    var foot=document.querySelector('.gbf'),t=false;
    function upd(){t=false;var y=window.scrollY||document.documentElement.scrollTop,nearFoot=false;
      if(foot){var r=foot.getBoundingClientRect();nearFoot=r.top<window.innerHeight*0.75}
      var on=y>window.innerHeight*0.7&&!nearFoot;bar.classList.toggle('is-on',on);bar.setAttribute('aria-hidden',on?'false':'true');
      var a=bar.querySelector('a');if(a)a.tabIndex=on?0:-1}
    addEventListener('scroll',function(){if(!t){t=true;requestAnimationFrame(upd)}},{passive:true});addEventListener('resize',upd);upd();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',go);else go();
})();
